/* eslint-disable @nx/enforce-module-boundaries */
import { toast } from '@intigral/shared';
import h from '../../helpers/common';
import user from '../../helpers/user';
import { __ } from '../../translations';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain';
import { IEntitlementService } from '@intigral/domain/lib/application/services/EntitlementService';
import { IPopcornService } from '@intigral/domain/lib/application/services/PopcornService';
import { getQitafProperty, resetQitafProperty } from './qitafServiceWrapper';
import { ISubscriptionService } from '@intigral/domain/lib/application/services/SubscriptionService';

export const ppvOneTimePurchaseApi = async ({
    eventData,
    pin,
    password,
    handlePurchase,
}: {
    eventData: any;
    pin?: string;
    password?: string;
    handlePurchase?: any;
}) => {
    const purchaseData = {
        payPerView: {
            eventId: eventData?.eventId,
            guid: eventData?.subscriptionGuid,
        },
    };

    if (pin) {
        purchaseData['pin'] = pin;
    } else if (password) {
        purchaseData['password'] = password;
    }

    const { authToken, username, authSign, identityToken, apiKey } = user.getUserInfo();

    const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
    const subscriptionService = container.resolve<ISubscriptionService>(DI.SERVICES.ISubscriptionService);
    // return
    return entitlementService
        .ppvPurchasePin(purchaseData, username, authToken, authSign, identityToken, apiKey)
        .then(async (response) => {
            const subscription = await subscriptionService.getSubscriptionStatus(
                user.getAPIKey(),
                username,
                authToken,
                identityToken
            );
            if (subscription) {
                user.updateUserSubscriptionsObject(subscription, false);
                const { ppvList } = subscription;
                if (handlePurchase) {
                    handlePurchase(ppvList);
                }
            }
            return response.data;
        })
        .catch((error) => {
            toast(__(`err_msg_${error?.data?.code}`), 'error');
        });
};

export const ppvGenerateOTPApi = async ({ eventData }) => {
    const payload = {
        payPerViews: [
            {
                eventId: eventData?.eventId,
                guid: eventData?.subscriptionGuid,
            },
        ],
        language: h.getLang(),
        qitafRefId: null,
    };
    const qitafRefId = getQitafProperty('qitafRefId');
    if (qitafRefId) {
        payload.qitafRefId = qitafRefId;
    }
    const { authToken, username, authSign, identityToken, apiKey } = user.getUserInfo() || {};
    const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
    return entitlementService
        .ppvPurchaseGenerateOtp(payload, username, authToken, authSign, identityToken, user.getAPIKey())
        .then((response) => {
            return response?.data;
        })
        .catch((error) => {
            toast(
                __(`err_msg_${error?.data?.code}`).replace(
                    '{userName}',
                    error?.data?.description?.split('username')[1]
                ),
                'error'
            );
            throw error;
        });
};

export const ppvVerifyOTPApi = async ({ otp, eventData, handlePurchase }) => {
    const payload = {
        payPerViews: [
            {
                eventId: eventData?.eventId,
                guid: eventData?.subscriptionGuid,
            },
        ],
        language: h.getLang(),
        qitafRefId: null,
        otp,
    };
    const qitafRefId = getQitafProperty('qitafRefId');
    if (qitafRefId) {
        payload.qitafRefId = qitafRefId;
    }
    const { authToken, username, authSign, identityToken } = user.getUserInfo() || {};
    const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
    const subscriptionService = container.resolve<ISubscriptionService>(DI.SERVICES.ISubscriptionService);
    return entitlementService
        .ppvPurchaseVerifyOtp(payload, username, authToken, authSign, identityToken, user.getAPIKey())
        .then(async (response) => {
            resetQitafProperty('qitafPoints');
            resetQitafProperty('qitafRefId');
            resetQitafProperty('qitafMsisdn');
            const subscription = await subscriptionService.getSubscriptionStatus(
                user.getAPIKey(),
                username,
                authToken,
                identityToken
            );
            if (subscription) {
                user.updateUserSubscriptionsObject(subscription, false);
                const { ppvList } = subscription;
                if (handlePurchase) {
                    handlePurchase(ppvList);
                }
            }
            return response;
        })
        .catch((error) => {
            toast(__(`err_msg_${error?.data?.code}`, { code: error?.data?.code }), 'error');
        });
};
